import React, { Component } from 'react';
import { Switch, Dialog, Classes, AnchorButton } from "@blueprintjs/core";
import { optionSource, areaOptionSource, exchangeTypesSource } from '../../../../../constatns/map';
import SearchInput from '../../../../custom/SearchInput';
import HTMLSelect from '../../../../custom/HtmlSelect';
import './index.css';


class Controller extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isPrice: true,
      isNA: false,
      reset: 1,
      showMessageDialog: '',
      fullScreenIcon: 'full-screen.svg',
      options: {searchResults:[], id:0}
    }
    this.handleSwitchChange = this.handleSwitchChange.bind(this);
    this.handleSearchInputClick = this.handleSearchInputClick.bind(this);
    this.selectChangeHandler = this.selectChangeHandler.bind(this);
    this.renderOptions = this.renderOptions.bind(this);
    this.messageDialogResult = this.messageDialogResult.bind(this);
    this.handleFullScreen = this.handleFullScreen.bind(this);
    this.exitHandler = this.exitHandler.bind(this);
    this.handleSearchInputChange = this.handleSearchInputChange.bind(this);
    this.getSearchResults = this.getSearchResults.bind(this);
    this.handleSelectSearchItem = this.handleSelectSearchItem.bind(this);
  }


  componentDidMount(){
    document.addEventListener('fullscreenchange', this.exitHandler);
    document.addEventListener('webkitfullscreenchange', this.exitHandler);
    document.addEventListener('mozfullscreenchange', this.exitHandler);
    document.addEventListener('MSFullscreenChange', this.exitHandler);
  }

  
  componentWillUnmount(){
    document.removeEventListener('fullscreenchange', this.exitHandler);
    document.removeEventListener('webkitfullscreenchange', this.exitHandler);
    document.removeEventListener('mozfullscreenchange', this.exitHandler);
    document.removeEventListener('MSFullscreenChange', this.exitHandler);
  }


  exitHandler() {
    if (!document.fullscreenElement && 
        !document.webkitIsFullScreen && 
        !document.mozFullScreen && 
        !document.msFullscreenElement) {
        this.setState({ fullScreenIcon: 'full-screen.svg' })
      }
  } 

  handleSwitchChange(e, key) {
    if (key === 'isPrice') {
      this.props.showPrice(!this.state.isPrice)
      this.setState({ isPrice: !this.state.isPrice })
    }
    else if (key === 'isNA') {
      this.props.showNA(!this.state.isNA)
      this.setState({ isNA: !this.state.isNA })
    }

  }

  handleSelectSearchItem(item){
    if (this.props.onSelectSearchItem){this.props.onSelectSearchItem(item)}
  }

  handleSearchInputClick(value) {
    let options = this.getSearchResults(value);
    this.setState({options})
  }

  handleSearchInputChange(value){
    let options = this.getSearchResults(value);
    this.setState({options})
  }

  getSearchResults(value){
    const { dataSource }= this.props;
    let res = {searchResults:[], id:Math.round(Math.random()*10000)};
    if(value){
      let sectors = dataSource.data;
      for(var s in sectors){
        let sector = dataSource.data[s];
        for(var i in sector.industries){
          let industrie = sector.industries[i];
          for(var t in industrie.tickers){
            let ticker = industrie.tickers[t];
            let symbol = ticker.symbol
            if(symbol.toLowerCase().startsWith(value.toLowerCase()))
              {res.searchResults.push({symbol:symbol, industrieId:industrie.id})}
          }
        }
      }
    }
    return res;
  }

  selectChangeHandler(value) {
    this.setState({ reset: Math.random(), showMessageDialog: value })
  }

  renderOptions(arr) {
    const { lang } = this.props;
    return arr(lang).map((item) => { return item.label })
  }

  messageDialogResult() {
    this.setState({ showMessageDialog: false })
  }

  handleFullScreen() {
    // let topNav = document.getElementById("main-top-navbar");
    // let bottomNav = document.getElementById("main-bottom-navbar");
    if ((document.fullScreenElement && document.fullScreenElement !== null) ||
      (!document.mozFullScreen && !document.webkitIsFullScreen)) {
      if (document.documentElement.requestFullScreen) {
        document.documentElement.requestFullScreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullScreen) {
        document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
      }
      this.setState({ fullScreenIcon: 'full-screen-exit.svg' })
      // topNav.style.display = 'none';
      // bottomNav.style.display = 'none';
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
      this.setState({ fullScreenIcon: 'full-screen.svg' })
      // topNav.style.display = '';
      // bottomNav.style.display = '';
    }
  }



  render() {
    const { lang } = this.props;
    const { reset, showMessageDialog, fullScreenIcon, options } = this.state;
    return (
      <div className='sc-market-map-controller'>
        <div className='sc-market-map-controller-switch-container'>
          <div className='sc-market-map-controller-fullscreen-icon-wrapper' onClick={this.handleFullScreen}>
            <img alt='' src={require(`../../../../../assets/images/${fullScreenIcon}`)} />
          </div>
          <SearchInput lang={lang} placeholder={{ fa: 'جستجو سهم', en: 'Search Stock' }} backgroundColor={'rgb(0, 43, 68)'} options={options} onSelect={this.handleSelectSearchItem}
            placeholderWhite onChange={this.handleSearchInputChange} onClick={this.handleSearchInputClick} optionsClass='sc-market-map-controllersearch-input-options'/>
          <div className='sc-market-map-controller-switch-wrapper'>
            <Switch className={lang === 'fa' ? '' : 'bp3-align-right'}
              checked={this.state.isPrice} label={lang === 'fa' ? 'نمایش قیمت' : 'Show Price'} onChange={(e) => this.handleSwitchChange(e, 'isPrice')} />
            <Switch className={lang === 'fa' ? '' : 'bp3-align-right'}
              checked={this.state.isNA} label={lang === 'fa' ? 'سهام بدون اطلاعات' : 'Not Available (N/A)'} onChange={(e) => this.handleSwitchChange(e, 'isNA')} />
          </div>
        </div>
        <div className='sc-market-map-controller-dropdown-container'>
          <HTMLSelect reset={reset} options={this.renderOptions(areaOptionSource)} onChange={this.selectChangeHandler} bgColor={'rgb(0, 43, 68)'} optionsClass='sc-m-select-oclass' selectClass='sc-m-select-sclass' className='sc-m-select-cont-fr' selColor='#000' lang={lang} />
          <HTMLSelect reset={reset} options={this.renderOptions(optionSource)} onChange={this.selectChangeHandler} bgColor={'rgb(0, 43, 68)'} optionsClass='sc-m-select-oclass' selectClass='sc-m-select-sclass' className='sc-m-select-cont-sec' selColor='#000' lang={lang} />
          <HTMLSelect reset={reset} options={this.renderOptions(exchangeTypesSource)} onChange={this.selectChangeHandler} bgColor={'rgb(0, 43, 68)'} optionsClass='sc-m-select-oclass' selectClass='sc-m-select-sclass' className='sc-m-select-cont-th' selColor='#000' lang={lang} />
        </div>
        <Dialog icon={null} onClose={this.messageDialogResult} canEscapeKeyClose={true} enforceFocus={true} isOpen={showMessageDialog} usePortal={true}>
          <div className='sc-market-map-controller-dialog'>
            <div className={Classes.DIALOG_BODY}>
              <p className='sc-market-map-controller-dialog-message'>
                <span>{lang === 'fa' ? ' برای دیدن ' : ' For See '}</span>
                <span>{showMessageDialog}</span>
                <span>{lang === 'fa' ? ' ابتدا وارد شوید ' : ' Please Login First '}</span>
              </p>
            </div>
            <div className={Classes.DIALOG_FOOTER}>
              <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                <AnchorButton style={{ width: '100px' }} className={Classes.INTENT_PRIMARY} onClick={this.messageDialogResult}>OK</AnchorButton>
              </div>
            </div>
          </div>
        </Dialog >
      </div>
    );
  }
}




export default Controller;


// Not Available (N/A)
// Show Price
// Search Ticker ...


// سهام بدون اطلاعات
// نمایش قیمت
// جستجوی سهم
